import { createContext, useContext } from 'react';

const FormContext = createContext(null);

export const useFormContext = () => {
    const context = useContext(FormContext);
    if (!context) {
        throw new Error('useFormContext must be used within a FormProvider');
    }
    return context;
};

export default FormContext;
